import * as _ from "lodash";
import { ActionTypes } from './action-types';
import { ICenterState, initialProductOwners } from "./state";
import { ICenterSummary, ICenter, ICenterSaturation, IProductOwner } from '@nkr/models/index';

// reducer interfaces

interface ISetCenterSummaryList {
    type: string,
    list: ICenterSummary[]
}

interface ISetCenterList {
    type: string,
    list: ICenter[]
}

interface ISetCenterSaturationList {
    type: string,
    list: ICenterSaturation[]
}

interface ISetProductOwnerList {
    type: string,
    productOwners: Record<string, IProductOwner>
}

interface IUpdateCenterSaturationDetails {
    type: string,
    centerId: number,
    notes: string,
    category: string,
    goal: number
}

export interface ISetAddAddress {
    type: string,
    addAddress: boolean
}

export interface ISetAddLabOption {
    type: string,
    addFollowUpLabOption: boolean
}

// reducer functions

const setCenterSummaryList = (state: ICenterState, action: ISetCenterSummaryList) => {
    state.summaryList = action.list;
    return state;
}

const setCenterList = (state: ICenterState, action: ISetCenterList) => {
    state.list = action.list;
    return state;
}


const setCenterSaturationList = (state: ICenterState, action: ISetCenterSaturationList) => {
    state.saturationList = action.list;
    return state;
}

const setProductOwnerList = (state: ICenterState, action: ISetProductOwnerList) => {
    state.productOwners = action.productOwners;
    return state;
}

const updateCenterSaturationDetails = (state: ICenterState, action: IUpdateCenterSaturationDetails) => {
    state.saturationList = state.saturationList.map(center => {
        if (center.id == action.centerId) {

            switch (action.type) {
                case ActionTypes.UPDATE_CENTER_NOTES_FOR_SAT:
                    center.notes = action.notes;
                    break;

                case ActionTypes.UPDATE_CENTER_CATEGORY:
                    center.category = action.category;
                    break;

                case ActionTypes.UPDATE_CENTER_SATURATION_GOAL:
                    center.saturationAnnualGoal = action.goal;
                    break;
            }

        }

        return center;
    });

    return state;
}

const setAddAddress = (state: ICenterState, action: ISetAddAddress) => {
    state.addAddress = action.addAddress;
    return state;
}

const setAddLabOption = (state: ICenterState, action: ISetAddLabOption) => {
    state.addFollowUpLabOption = action.addFollowUpLabOption;
    return state;
}

// reducer creation

var initialState: ICenterState = {
    summaryList: [],
    list: [],
    saturationList: [],
    productOwners: initialProductOwners, 
    addAddress: false,
    addFollowUpLabOption: false
};

const createReducer = (initialState: ICenterState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = _.cloneDeep(state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
    [ActionTypes.SET_CENTER_SUMMARY_LIST]: setCenterSummaryList,
    [ActionTypes.SET_CENTER_LIST]: setCenterList,
    [ActionTypes.SET_CENTER_SATURATION_LIST]: setCenterSaturationList,
    [ActionTypes.SET_PRODUCT_OWNER_LIST]: setProductOwnerList,
    [ActionTypes.SET_ADD_ADDRESS]: setAddAddress,
    [ActionTypes.SET_ADD_FOLLOWUP_LAB_OPTION]: setAddLabOption,
    [ActionTypes.UPDATE_CENTER_NOTES_FOR_SAT]: updateCenterSaturationDetails,
    [ActionTypes.UPDATE_CENTER_CATEGORY]: updateCenterSaturationDetails,
    [ActionTypes.UPDATE_CENTER_SATURATION_GOAL]: updateCenterSaturationDetails
}

export const Reducer = createReducer(initialState, handlers);
